module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido20+.a09c29c6.svg";